export default __webpack_public_path__ + "static/media/receipt_header_logo.07f99525.png";